const Backbone = require('backbone');
const window = require('window');
const SelectBoxView = require('views/store/common/components/select_box/select_box');
const CartItemModel = require('app/models/store/client/cart/item');
const format = require('format');

module.exports = Backbone.View.extend(
	/** @type {Partial<BackboneExtensions.QuickAddProductCard>} */ ({
		el: '.quick-add-product-cart',
		events: {
			'click .js-quick-add-to-cart': 'addToCart'
		},
		initialize: function(options = {}) {
			this.model = options.model;
			this.urlTrackingKey = options.urlTrackingKey;
			this.selectedFinish = options.selectedFinish;
			this.hideAddToCart = options.hideAddToCart;
			this.$addToCartBtn = this.$el.find('.js-quick-add-to-cart');
			this.$configBtn = this.$el.find('.js-configure-product');
			this.listenTo(Backbone, 'finish:selected', this.finishSelected);
			const $selectBox = this.$el.find('.js-select-box-component');
			this.selectBoxView = $selectBox.data('componentView');
			// this component is possibly rendered client side
			if (!this.selectBoxView) {
				this.selectBoxView = new SelectBoxView({
					selectEvent: 'finish:selected',
					el: $selectBox
				});
			} else {
				this.selectBoxView.setOptions({ selectEvent: 'finish:selected' });
			}
			let defaultIndex = 0;
			if (this.selectedFinish) {
				defaultIndex = this.model.finishes.map((finish) => finish.uniqueId).indexOf(this.selectedFinish.uniqueId);
			}
			this.selectBoxView.setSelectedByIndex(defaultIndex);
			if (this.hideAddToCart) {
				this.$el
					.find('.js-product-card-actions')
					.removeClass('flex')
					.addClass('dn');
			}
		},
		/**
		 * @param {*} data
		 * @returns {void}
		 */
		finishSelected(data) {
			const { index } = data;
			if (!data.shouldPropagateChange) {
				return;
			}
			this.selectedFinish = this.model.finishes[index];
			const imageUrl = `//s2.img-b.com/${window.dataLayer.storeName}${this.selectedFinish.imagePaths[220]}`;
			const productLink = `${this.model.alternateLink}?uid=${this.selectedFinish.uniqueId}&qat=${this.urlTrackingKey}`;
			// Update the finish specific properties
			this.$el.find('.js-alternate-image').attr('src', imageUrl);
			this.$el.find('.js-alternate-price').html(format.currency(this.selectedFinish.cost));
			if (this.selectedFinish.inventory) {
				this.$addToCartBtn.removeClass('dn');
				this.$configBtn.removeClass('dn');
				this.$el.find('.js-view-product').addClass('dn');
				this.$el.find('.js-alternate-stock').html(`${this.selectedFinish.inventory} in stock`);
			} else {
				this.$el.find('.js-alternate-stock').html('');
				this.$addToCartBtn.addClass('dn');
				this.$configBtn.addClass('dn');
				this.$el.find('.js-view-product').removeClass('dn');
			}
			this.$el.find('.js-alternate-link').attr('href', productLink);
		},
		/**
		 * @param {*} product
		 * @returns {boolean}
		 */
		shouldRedirectToConfigPage(product) {
			if (!window.BCOM.device.isDesktop) {
				return false;
			}
			return product.recommendedOptions && product.recommendedOptions.length > 0;
		},
		/**
		 * @param {Event} e
		 * @returns {void}
		 */
		addToCart(e) {
			const uniqueId = this.selectBoxView.getValue(),
				$btn = $(e.currentTarget);

			if (this.shouldRedirectToConfigPage(this.model)) {
				window.location.assign(`${this.model.alternateLink}/configure?uid=${this.selectedFinish.uniqueId}`);
				return;
			}
			if (uniqueId) {
				const cartItemModel = new CartItemModel({
					quantity: 1,
					uniqueId: uniqueId
				});
				$btn.button('loading');
				cartItemModel.save(null, {
					success: (model, response) => {
						window.dataLayer.cartQuantity += 1;
						window.BCOM.notifications.render('You have added an item to your cart', 'success');
						window.BCOM.util.trackCartAddition(model.attributes);
						Backbone.trigger('addToCart:productAdded', model);
						Backbone.trigger('omniture:productaddtocart', 'quick-add', response, model, null);
						Backbone.trigger('cart:quantityChanged', window.dataLayer.cartQuantity);
						$btn.button('reset');
					},
					error: () => {
						window.BCOM.notifications.render('There was a problem adding this item to your cart. Please try again.', 'danger');
						$btn.button('reset');
					}
				});
			}
		}
	})
);
